import { /* makeStyles, Theme, */ Typography } from "@material-ui/core";
import React from "react";
import careerImage from "./Assets/career.svg";
import clockImage from "./Assets/clock.svg";
import learningImage from "./Assets/learning.svg";
import mobileImage from "./Assets/mobile.svg";
import navigationImage from "./Assets/navigation.svg";
import payImage from "./Assets/pay.svg";
import talentImage from "./Assets/talent.svg";
import videoImage from "./Assets/video.svg";
import Categories from "./Categories";
import CategoryData from "./CategoryData";
import ContactInformation from "./WDContactInformation";

// const useStyles = makeStyles((theme: Theme) => ({}));

const categories = [
  {
    title: "Getting Started",
    icon: navigationImage,
    subCategories: [
      {
        icon: videoImage,
        mainLinks: [
          {
            title: "EHW Partner Training - End to End Process Review",
            link: "https://d1xzj63c8dqlov.cloudfront.net/video/69ba1040-38c9-4647-93a2-22daf3f09fa8",
          },
        ],
        jobAids: [
          {
            title: "Pre-Hire Health Screening Process",
            link: "https://d1xzj63c8dqlov.cloudfront.net/document/c69900bb-6f1a-48f1-b8ea-3d5b05fbf108",
          },
          {
            title: "Edit Health Screening Object",
            link: "https://d1xzj63c8dqlov.cloudfront.net/document/5a724ce2-0356-460c-8ea9-ad04dfb2bf91",
          },
          {
            title: "Pre-Hire Health Screening",
            link: "https://d1xzj63c8dqlov.cloudfront.net/document/fcd84bc6-c67a-456d-8b4d-d957aea5696e",
          },
          {
            title: "EL Health Screening Audit Report",
            link: "https://d1xzj63c8dqlov.cloudfront.net/document/326335e6-2fee-4e55-9e1d-afc7b2a70a33",
          },
          {
            title: "EL TB Screening Report",
            link: "https://d1xzj63c8dqlov.cloudfront.net/document/d0963cd7-10eb-45a8-8afa-f0666c9551e6",
          },
        ],
      },
    ],
  },
] as CategoryData[];

export default function EHWCLinks() {
  // const classes = useStyles();

  return (
    <React.Fragment>
      <Typography variant="h4">Quick Links for EHWC</Typography>
      <br />
      <Categories data={categories} />
      <br />
      <ContactInformation />
    </React.Fragment>
  );
}
